export enum CONNECTIONS_PAYOUT_ORIGIN {
  AUTO = 'AUTO',
  USER = 'USER'
};
